import React, { useRef, useState } from 'react'
import Timer from '../../timer/timer';
import Audio from '../../audio/audio';
import Video from '../../video/video'
import "./foodPuzzle.css";
import Modal from 'react-modal';

import styled, { keyframes } from 'styled-components';
import { tada, fadeIn} from 'react-animations';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: 'none',
        border: 'none',
    },
};

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');

const Animation = keyframes`${tada}`;

const FadeInDiv = styled.div`
  animation: 3s ${Animation};
`;

const AnimationSlide = keyframes`${fadeIn}`;

const SlideDownInDiv = styled.div`
  animation: 2s ${AnimationSlide};
`;
const FoodPuzzle = (props) => {

    const actorName = "JOE";
    const actorTitle = "Security Guard";
    const playVideo = useRef(null);
    const playAudio = useRef(null);

    const timerRef = useRef(null);
    let btnRef = useRef();

    const input = React.createRef();

    // const posterURL = './actors/JOE.png';

    const posterURL = './actors/Black_BG.jpg';

    const congratulateVideoURL = './videos/CNE-05-Puzzle-Solved.mp4';

    const waitingVideos = ['./videos/waitings/Joe_Waiting.mp4', './videos/waitings/Joe_Waiting.mp4', './videos/waitings/Joe_Waiting.mp4',]

    const promptVideos = ['./videos/CNE-04-Prompt-01.mp4', './videos/CNE-04-Prompt-02.mp4', './videos/CNE-04-Prompt-03.mp4'];

    const [promptIndex, setPromptIndex] = useState(null);

    const [currentVideoURL, setCurrentVideoURL] = useState(null)

    const loopVideos = (src) => {
        if (currentVideoURL === null) {
            setCurrentVideoURL(waitingVideos[0]);
            playVideo.current(waitingVideos[0]);
            return;
        }

        if (currentVideoURL === waitingVideos[0]) {
            
            setCurrentVideoURL(waitingVideos[1]);
            playVideo.current(waitingVideos[1]);
        } else if (currentVideoURL === waitingVideos[1]) {
           
            setCurrentVideoURL(waitingVideos[2]);
            playVideo.current(waitingVideos[2]);
        } else if (currentVideoURL === waitingVideos[2]) {
            
            setCurrentVideoURL(waitingVideos[0]);
            playVideo.current(waitingVideos[0]);
        } else {
            
            setCurrentVideoURL(waitingVideos[0]);
            playVideo.current(waitingVideos[0]);
        }
    }

    //modal
    const [isBlur, setIsBlur] = useState("blur");

    function showClear(event) {
        event.stopPropagation();
        setIsBlur("");
    }

    const [modalIsOpen, setIsOpen] = useState(false);

    const [gameOverModalIsOpen, setGameOverModalIsOpen] = useState(false);

    function openModal() {
        setIsBlur('blur');
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }
    function openGameOverModal() {
        setGameOverModalIsOpen(true);
    }

    function closeGameOverModal() {
        timerRef.current(props.initialTimeOut);
        setGameOverModalIsOpen(false);
    }
    function restartGame() {
        setGameOverModalIsOpen(false);
        props.goToStep(null, 'LandingPage');

    }

    //modal end

    const handleSubmit = (event) => {
       
        event.preventDefault();
        if (input.current.value.trim().toUpperCase() === "FRYER") {
            if (btnRef.current) {
                btnRef.current.setAttribute("disabled", "disabled");
            }
            playVideo.current(congratulateVideoURL);
            setCurrentVideoURL(congratulateVideoURL);

        } else {
            if (promptIndex === null) {
                setPromptIndex(0);
                playVideo.current(promptVideos[0]);
            } else if (promptIndex === 0) {
                setPromptIndex(1);
                playVideo.current(promptVideos[1]);
            } else if (promptIndex === 1) {
                setPromptIndex(2);
                playVideo.current(promptVideos[2]);
            } else if (promptIndex === 2) {
                setPromptIndex(0);
                playVideo.current(promptVideos[0]);
            } else {
                setPromptIndex(0);
                playVideo.current(promptVideos[0]);
            }

        }
    }
    const gotoFailed = (event, args) => {
      
        if (gameOverModalIsOpen) {

        } else {
            openGameOverModal();
        }

    }
    const updateVideoStatue = (value, src) => {
       

        if (value === "ended") {
            if (currentVideoURL === congratulateVideoURL) {
                props.goToStep(null, 'FoodBuildingIntro');
            } else if (waitingVideos.includes(currentVideoURL)) {
                loopVideos(src);
            } else if (promptVideos.includes(currentVideoURL)) {
                loopVideos(src);
            } else {
                loopVideos(src);
            }

        }
    }
    const updateAudioStatue = (value) => {
        
    }

    const setUpWarningSound = () => {
       
        if (playAudio.current) {
            playAudio.current('./musics/30SecondTimer.mp3');
        }
    }

    return (
        <>

            <div className="foodPuzzle">
                <div className='puzzleContainer'>
                    <div className='pgTitle'>
                        <div className='gameTitleContainer'>
                        <div className='pgName'>Joe's Security Room</div>
                        <div className='pgDesc'>Food Poem</div>
                        </div>
                        <SlideDownInDiv>
                        <div className='hintContainer'>
                        <p>Look closely at the colour of the food stains, each colour represents a condiment and a letter. Can you decipher the secret word?</p>
                        </div>
                        </SlideDownInDiv>
                    </div>

                    <div className='puzzleContent'>
                        <div className='item1'></div>
                        <div className='item2'></div>
                        <div className='item3'></div>
                        <div className='item4'></div>
                        <div className='item5'></div>

                        <FadeInDiv>
                            <div className='item6'></div>
                            <div className='item7'></div>
                        </FadeInDiv>
                        <div className='item8'></div>
                        <div className='item9'></div>
                        <div className='item10'></div>

                    </div>

                </div>

                <div className='videoContainer'>
                    <Timer seconds={props.seconds} gotoFailed={gotoFailed} isReversed={props.isReversed} setUpWarningSound={setUpWarningSound} timerRef={timerRef} updateTimerValue={props.updateTimerValue} />

                    <Video VideoURL="./videos/3_2_Clues.mp4" actorName={actorName} actorTitle={actorTitle} poster={posterURL} updateVideoStatue={updateVideoStatue} playVideo={playVideo} />
                    <div className='helpContainer'>
                        <div className='helpButton' onClick={openModal}></div>
                        <Modal
                            isOpen={modalIsOpen}
                            style={customStyles}
                            contentLabel="Food puzzle help"
                        >

                            <div className="helpPopup" onClick={closeModal}>
                                <div className='helpMessageContainer'>
                                    <div className='helpLabel' />
                                    <div className='whitePaperContainer' />
                                    <div className='helpIcon' />
                                    <div className='messageContainter'>
                                    <div className='helpMessage'>
                                        <div className='helpTitle'>Stains and condiments! </div>
                                        <div className='helpDesc'>Hmm… those condiments have stained the poem. Are the stains near any letters? Should we read them in any specific order?</div> 
                                    </div>
                                    <div className='helpButtonsContainer'>
                                        <button className='revealButton' onClick={showClear} >Click to reveal the clue!</button>
                                        <div className={`blurredClue ${isBlur}`}>
                                            <div>The word starts with an F and it ends with an R. </div>
                                            <div>It used to make delicious carnival foods!</div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                        <Modal
                            isOpen={gameOverModalIsOpen}
                            style={customStyles}
                            contentLabel="Game over"
                        >

                            <div className="timeOutPopup">
                                <div className='timeoutContainer'>
                                    <div className='timeoutLabel' />
                                    <div className='paperContainer' />
                                    <div className='timeoutPictures'>
                                        <div className='pic1'></div>
                                        <div className='pic2'></div>
                                        <div className='pic3'></div>
                                    </div>
                                    <div className='timeoutMessage'>
                                        Oops you've run out of time!
                                    </div>
                                    <div className='timoutButtonsContainer'>
                                        <button className='timeoutButton' onClick={closeGameOverModal} >Continue?</button>
                                        <button className='timeoutButton' onClick={restartGame}>Restart</button>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div>
                        <form onSubmit={handleSubmit} className="formContainer">
                            <div>
                                <label >
                                    <input className="inputField" type="text" placeholder='Type the answer here' ref={input} />
                                </label>
                            </div>
                            <input className="submitButton" type="submit" ref={btnRef} value="Submit" />
                        </form>
                    </div>
                   
                </div>
                <Audio AudioURL="./musics/the-crackdown.mp3" autoPlay loop updateAudioStatue={updateAudioStatue} playAudio={playAudio} />
            </div>
        </>
    );

}

export default FoodPuzzle;